import Field from '../Field';

class Json extends Field {
  sanitize(force = false) {
    super.sanitize(force);

    // No sanitizing at this time
    this.value.forEach((val, index) => {
      try {
        this.setValue(typeof val === 'string' ? JSON.parse(val) : val, index);
        this.setDisplayValue(typeof val === 'string' ? val : JSON.stringify(val, null, 2), index);
      } catch (err) {
        // this.setValue({}, index);
        // this.setDisplayValue('{}', index);
      }
    });

    return this;
  }

  validate() {
    super.validate();

    this.value.forEach((val, index) => {
      if (!this.needsValidation(index)) {
        return;
      }

      try {
        if (typeof val === 'string') {
          JSON.parse(val);
        } else {
          JSON.parse(JSON.stringify(val));
        }
      } catch (err) {
        this.invalidate('Invalid JSON.', index);
      }
    });

    return this.isValid();
  }
}

export default Json;
